import Select, { components } from 'react-select';

import { CustomCheckbox } from '@ce-cfbdigital/cgl-cfb-fe-foundation';
import PropTypes from 'prop-types';

import CustomIcon from '../CustomIcons';

import './styles/index.css';

const CustomSelect = props => {
  const {
    displayIcon,
    selectLabel,
    labelClass,
    withCheckBox,
    displayOpenIcon,
    customLabelDisplay,
    classes,
    isMandatory,
    componentsObj
  } = props;

  /**
   * @method Option
   * @description option item for drop down in select and multiselect
   * @return Component dom.
   */
  const Option = optionProps => {
    const { data, value, isSelected, children } = optionProps;
    return (
      <div>
        <components.Option {...optionProps}>
          <CustomCheckbox
            onChange={() => {}}
            checked={value === 'Select All' ? data.isSelected : isSelected}
            label={customLabelDisplay ? children : data.label}
          />
        </components.Option>
      </div>
    );
  };

  /**
   * @method MultiValue
   * @description Component used to display a selected option in the input
   * @return Component dom.
   */
  const MultiValue = multiProps => {
    const {
      children,
      data: { label }
    } = multiProps;
    return (
      <components.MultiValue {...multiProps}>
        <span>{customLabelDisplay ? children : label}</span>
      </components.MultiValue>
    );
  };

  /**
   * @method DropdownIndicator
   * @description designed to indicate to users that this is a select dropdown
   * @return Component dom.
   */
  const DropdownIndicator = iconProps => {
    const {
      selectProps: { menuIsOpen }
    } = iconProps;
    return (
      components.DropdownIndicator && (
        <components.DropdownIndicator {...iconProps}>
          {menuIsOpen ? displayOpenIcon : displayIcon}
        </components.DropdownIndicator>
      )
    );
  };

  const optionObj = withCheckBox ? { MultiValue, Option, DropdownIndicator } : { DropdownIndicator };
  const customComponents = { ...optionObj, ...componentsObj };
  const requiredClass = isMandatory ? 'required' : '';
  return (
    <>
      {selectLabel && <h4 className={`zeta b select-label ${labelClass} ${requiredClass}`}>{selectLabel}</h4>}
      <Select
        components={customComponents}
        classNamePrefix="react-select"
        className={`basic-react-select ${classes}`}
        {...props}
      />
    </>
  );
};

CustomSelect.defaultProps = {
  isClearable: false,
  selectLabel: null,
  isSearchable: false,
  displayIcon: <CustomIcon type="dropdownArrow" className="dropdown-arrow" size="20" />,
  displayOpenIcon: <CustomIcon type="dropUpArrow" className="dropup-arrow" size="20" />,
  labelClass: '',
  isMulti: false,
  withCheckBox: false,
  hideSelectedOptions: false,
  classes: '',
  isMandatory: false,
  isDisabled: false,
  customLabelDisplay: false,
  componentsObj: {}
};

CustomSelect.propTypes = {
  isClearable: PropTypes.bool,
  isSearchable: PropTypes.bool,
  displayIcon: PropTypes.node,
  displayOpenIcon: PropTypes.node,
  selectLabel: PropTypes.string,
  labelClass: PropTypes.string,
  classes: PropTypes.string,
  isMulti: PropTypes.bool, // multi select
  withCheckBox: PropTypes.bool, // multi select with checkbox
  hideSelectedOptions: PropTypes.bool, // item will not removed from multi select dropdown
  customLabelDisplay: PropTypes.bool, // multi select
  isMandatory: PropTypes.bool,
  isDisabled: PropTypes.bool,
  componentsObj: PropTypes.instanceOf(Object)
};

export default CustomSelect;
